"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logLoginOnce = exports.logAsync = void 0;
var tslib_1 = require("tslib");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var interfaces_1 = require("@monorepo/interfaces");
var logAsync = function (data, token) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var config, error_1;
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                config = {
                    baseURL: process.env.REACT_APP_REST_BASE_URL,
                    headers: {
                        Authorization: "Bearer ".concat(token),
                        'content-type': 'application/json',
                    },
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.post('/log', data, config)];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                console.log(error_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.logAsync = logAsync;
var LOGIN_SESSION_KEY = 'tmz.loggedLoginSession';
/**
 * Record a login, at most once per Keycloak session.
 *
 * Keycloak's onAuthSuccess also fires when an existing session is silently
 * restored on a page load, so logging unconditionally would count every
 * refresh as a new login. Keycloak issues a fresh session_state for each real
 * sign-in, so we remember the last one we logged and only send again when it
 * changes.
 *
 * Deliberately uses the account's own token rather than an impersonation
 * token, so an admin impersonating a dealer is not recorded as that dealer
 * signing in.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var logLoginOnce = function (keycloakClient) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var sessionState, token, error_2;
    var _a;
    return (0, tslib_1.__generator)(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                if (!(keycloakClient === null || keycloakClient === void 0 ? void 0 : keycloakClient.authenticated)) {
                    return [2 /*return*/];
                }
                sessionState = (_a = keycloakClient === null || keycloakClient === void 0 ? void 0 : keycloakClient.tokenParsed) === null || _a === void 0 ? void 0 : _a.session_state;
                token = keycloakClient === null || keycloakClient === void 0 ? void 0 : keycloakClient.token;
                if (!sessionState || !token) {
                    return [2 /*return*/];
                }
                if (window.localStorage.getItem(LOGIN_SESSION_KEY) === sessionState) {
                    return [2 /*return*/];
                }
                // Written before the request so a slow or failed call cannot produce a
                // burst of duplicate logins.
                window.localStorage.setItem(LOGIN_SESSION_KEY, sessionState);
                return [4 /*yield*/, (0, exports.logAsync)({ type: interfaces_1.LogType.LOGIN }, token)];
            case 1:
                _b.sent();
                return [3 /*break*/, 3];
            case 2:
                error_2 = _b.sent();
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.logLoginOnce = logLoginOnce;
